const CommentarySkeleton = ({ count = 3 }) => {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="bg-themeOverlay w-full animate-pulse min-h-[50px] "
        />
      ))}
    </div>
  );
};

export default CommentarySkeleton;
